import { ExperienceSource } from 'model/IExperience';
import { reqWithABTest } from 'utils/abTesting';
import { getExperimentByName } from 'utils/abTests';
import req from 'utils/req';

const seasonalPricing = getExperimentByName('italianCitiesPricing');

type SuggestionsResponse = { suggestions: ExperienceSource[] };

export default {
  getById: async (
    id: string,
    lang: string,
    currency: string,
  ): Promise<ExperienceSource[]> => {
    const queryParams = new URLSearchParams({
      lang,
    });

    queryParams.set('currency', currency);

    try {
      const response = (await reqWithABTest(
        req(
          `${URL_API_HOST}/api/v3/experience/suggestions/${id}?${queryParams.toString()}`,
        ).get,
        seasonalPricing.id,
      )()) as SuggestionsResponse;

      return response?.suggestions ?? [];
    } catch (error) {
      console.error('Error fetching suggestions by ID:', error);
      return [];
    }
  },
};
